import Block from "@/components/wrappers/block"
import Link from "next/link"
import Arrow from "@/common/icons/arrow"
import styles from "./link-list.module.css"

export default function LinkList({ block }) {
  const { attrs } = block

  if (attrs.links.length === 0) {
    return null
  }

  const items = attrs.links.map((item, key) => {
    let link

    if (item.url === null) {
      link = item.label
    } else {
      link = (
        <Link href={item.url} prefetch={false} className="leading-8 underline">
          {item.label}
        </Link>
      )
    }

    if (item.url !== null && item.target !== "") {
      link = (
        <a
          href={item.url}
          target={item.target}
          rel={item.rel}
          className="leading-8 underline">
          {item.label}
        </a>
      )
    }

    return (
      <li key={key}>
        <div className="icon-wrapper">
          <div className="icon">
            <Arrow className="w-4" />
          </div>
        </div>
        {link}
      </li>
    )
  })

  const gap = attrs?.blockGap || "small"

  return (
    <Block block={block} width="column" gap={gap} className={styles.linkList}>
      <ul>{items}</ul>
    </Block>
  )
}
